// extracted by mini-css-extract-plugin
module.exports = {"input":"diagnosis_input__qa1e5","label":"diagnosis_label__hmmeQ","text":"diagnosis_text__2b6sZ"};